import { Component, OnInit, Output, Input, ViewChild, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { EntityCodes } from '../../Models/EnumModels';
import { ListRequest, ShiftSetUpModel, StaffAssignmentFilter, SaveShiftResponse, ShiftSetupFilter } from '../../Models/RequestModels';
import { Staff_Search_Assigment } from '../../Models/ResponseModels';
import { UserService } from '../../Services/UserService';
import { ShiftSetUp } from '../ShiftSetUp/ShiftSetUp';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as alasql from 'alasql';
import * as _ from "lodash";

import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'MultipleLoginLogout',
    templateUrl: './MultipleLoginLogout.html',
})

export class MultipleLoginLogout extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @Input() SaveShiftResponse: SaveShiftResponse;
    @Input() AllStaffList: Array<any>;

    ModalRef: NgbModalRef;
    Model: ShiftSetUpModel;
    FilterModel: ShiftSetupFilter;
    StaffList: Array<any>;
    ClonedStaffList: Array<any>;
    AllStaffAdded: boolean;
    MultipleLoginStaffList: Array<any>;
    DisableModalOpenEvent: boolean = false;
    isCollapsed: boolean;
    HasFilter: boolean = false

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, protected userService: UserService, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
        this.FilterModel = new ShiftSetupFilter();
        this.FilterModel.ClearFilters();
    }

    Open(reqModel: ShiftSetUpModel): void {
        if (this.DisableModalOpenEvent) return;

        this.FilterModel.ClearFilters();
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.isCollapsed = true;
        this.Model = reqModel;
        this.MultipleLoginStaffList = [];
        this.StaffList = _.cloneDeep(this.AllStaffList);
        this.StaffList = this.StaffList.map((row) => {
            row.AddedToMultipleLoginLst = false;
            return row;
        })
        this.AllStaffAdded = false;
        this.ClonedStaffList = this.StaffList;
        this.LoadFilterStaffData();

        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.FilterModel.Keyword = '';
            this.DisableModalOpenEvent = false;
        });
    }

    LoadFilterStaffData() {
        let queryString = 'SELECT * FROM ? where 1=1 ';
        let searchKeyword: string;
        this.HasFilter = false;
        if (this.FilterModel.StaffMapped != "" || this.FilterModel.ServiceStatus != "" || this.FilterModel.LoginStatus != "") {

            queryString += this.FilterModel.StaffMapped + ' ' + this.FilterModel.ServiceStatus + ' ' + this.FilterModel.LoginStatus;
            this.HasFilter = true;
        }

        if (this.FilterModel.Keyword.trim() != "") {
            searchKeyword = '%' + this.FilterModel.Keyword.trim().toLocaleUpperCase() + '%';
            queryString += ' and UCASE(Description) like ? or UCASE(SkillName) like ? or UCASE(SectionName) like ?';
            this.StaffList = alasql(queryString, [this.ClonedStaffList, searchKeyword, searchKeyword, searchKeyword]);
            this.HasFilter = true;
        }
        else {
            this.StaffList = alasql(queryString, [this.ClonedStaffList]);
        }

        if (typeof this.FilterModel.SkillId == "string") {
            this.FilterModel.SkillId = parseInt(this.FilterModel.SkillId);
        }

        if (this.FilterModel.SkillId != 0) {
            this.StaffList = this.StaffList.filter((item) => {
                if (item.Skills.indexOf(this.FilterModel.SkillId) >= 0)
                    return item;
            });
            this.HasFilter = true;
        }

        //if (this.FilterModel.OnlySelectedStaff) {
        //    this.StaffList = alasql('Select * From ? where Selected == true', [this.StaffList]);
        //    this.HasFilter = true;
        //}

        let SelectedStaffCount: number = 0;
        this.StaffList.forEach(row => {
            if (row.AddedToMultipleLoginLst == true) {
                SelectedStaffCount++;
            }
        })
        if (SelectedStaffCount && SelectedStaffCount == this.StaffList.length)
            this.AllStaffAdded = true;
        else
            this.AllStaffAdded = false;
    }

    UpdateStaffData(StaffLst: any): void {
        StaffLst.forEach(StaffDetails => {
            let index = this.AllStaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (index >= 0) {
                this.AllStaffList[index].IsLoggedIn = StaffDetails.LoginStatus;
                this.AllStaffList[index].AllOpenCalls = StaffDetails.AllOpenCalls || 0;
                this.AllStaffList[index].OpenCalls = StaffDetails.OpenCalls || 0;
            }

            let index_ = this.StaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (index_ > -1) {
                this.StaffList[index_].IsLoggedIn = StaffDetails.LoginStatus;
                this.StaffList[index_].AllOpenCalls = StaffDetails.AllOpenCalls || 0;
                this.StaffList[index_].OpenCalls = StaffDetails.OpenCalls || 0;
            }

            let pointer = this.ClonedStaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (pointer >= 0) {
                this.ClonedStaffList[pointer].IsLoggedIn = StaffDetails.LoginStatus;
                this.ClonedStaffList[pointer].AllOpenCalls = StaffDetails.AllOpenCalls;
                this.ClonedStaffList[pointer].OpenCalls = StaffDetails.OpenCalls;
            }

            this.shiftSetUp.SectionSkillStaffData.forEach(Section => {
                Section.Skills.forEach(Skill => {
                    let index = Skill.Staff.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
                    if (index >= 0) {
                        Skill.Staff[index].IsLoggedIn = StaffDetails.LoginStatus;
                    }
                })
            });
        })

    }

    UpdateDeviceData(staffId: number): void {
        this.shiftSetUp.SectionSkillStaffData.forEach(Section => {
            Section.Skills.forEach(Skill => {
                let index = Skill.Staff.findIndex(obj => obj.StaffId == staffId);

                if (this.shiftSetUp.ShiftResponseModel.ListStaffDevices.findIndex(item => item.StaffId == staffId) >= 0) {
                    this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                    this.StaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                    this.ClonedStaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                    if (index >= 0) Skill.Staff[index].HasDevices = true;
                }
                else {
                    this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                    this.StaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                    this.ClonedStaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                    if (index >= 0) Skill.Staff[index].HasDevices = false;
                }

            })
        });

    }

    AddStaffToMultipleLogin(Staff: any, event): void {
        if (event.target.checked) {
            let index = this.MultipleLoginStaffList.findIndex(obj => obj.StaffId == Staff.StaffId);
            if (index < 0)
                this.MultipleLoginStaffList.push(Staff);
            let index_ = this.ClonedStaffList.findIndex(a => a.StaffId == Staff.StaffId);
            this.ClonedStaffList[index_].AddedToMultipleLoginLst = true;
        }
        else {
            let index = this.MultipleLoginStaffList.findIndex(obj => obj.StaffId == Staff.StaffId);
            if (index >= 0)
                this.MultipleLoginStaffList.splice(index, 1);
            let index_ = this.ClonedStaffList.findIndex(a => a.StaffId == Staff.StaffId);
            this.ClonedStaffList[index_].AddedToMultipleLoginLst = false;
        }
        //this.LoadFilterStaffData();
    }

    MultipleStaffInOut(event): void {
        this.MultipleLoginStaffList = [];
        if (event.target.checked) {
            this.StaffList.forEach(Staff => {
                this.MultipleLoginStaffList.push(Staff);
                Staff.AddedToMultipleLoginLst = true;
                this.ClonedStaffList.find(a => a.StaffId == Staff.StaffId).AddedToMultipleLoginLst = true;
            });
        }
        else {
            this.StaffList.forEach(Staff => {
                Staff.AddedToMultipleLoginLst = false;
                this.ClonedStaffList.find(a => a.StaffId == Staff.StaffId).AddedToMultipleLoginLst = false;
            })
        }
        //this.LoadFilterStaffData();
    }

    onClearFilter() {
        this.FilterModel.ClearFilters();
        this.LoadFilterStaffData();
    }
}
